import api from './api';
import type {
  GetSettingsResponse,
  NotificationSettings,
  UpdateUserNotificationPreferencesPayload,
  UpdateUserNotificationPreferencesResponse,
  UserNotification,
} from '../types/notification';

export const notificationService = {
  getNotificationSettings: async (): Promise<GetSettingsResponse> => {
    const response = await api.get('/company/notification-settings');
    return response.data;
  },

  updateNotificationSettings: async (payload: {
    reminders: Array<{ value: number; unit: 'minutes' | 'hours' | 'days' }>;
    is_enabled: boolean;
  }): Promise<NotificationSettings> => {
    const response = await api.put('/company/notification-settings', payload);
    return response.data;
  },

  resyncNotifications: async (): Promise<void> => {
    await api.post('/company/notification-settings/resync');
  },

  listNotifications: async (params?: {
    limit?: number;
    before?: string;
  }): Promise<{ items: UserNotification[] }> => {
    const query = new URLSearchParams();
    if (params?.limit) {
      query.set('limit', String(params.limit));
    }
    if (params?.before) {
      query.set('before', params.before);
    }
    const response = await api.get(
      `/notifications${query.toString() ? `?${query.toString()}` : ''}`
    );
    return response.data;
  },

  getUnreadCount: async (): Promise<{ count: number }> => {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },

  markNotificationRead: async (id: string): Promise<void> => {
    await api.post(`/notifications/${id}/read`);
  },

  markAllNotificationsRead: async (): Promise<void> => {
    await api.post('/notifications/read-all');
  },

  updateMyNotificationPreferences: async (
    payload: UpdateUserNotificationPreferencesPayload
  ): Promise<UpdateUserNotificationPreferencesResponse> => {
    const response = await api.put('/users/me/notification-preferences', payload);
    return response.data;
  },
};
